/* Cart API functions */
export function fetchCartData() {
  var url = '/cart.js'
  return fetch(url).then(function (response) {
    return response.json().then(function (content) {
      return content;
    })
  }) 
}

export function cartAdd(variantId, quantity, properties) {
  const url = `${Shopify.routes.root}cart/add.js`;
  let body = {
    id: String(variantId),
    quantity: quantity
  };
  // Add properties only if it is defined
  if (properties) {
    body.properties = properties;
  }
  
  const requestOptions = {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(body)
  };
  return fetch(url, requestOptions)
    .then(response => response.json())
    .catch(error => {
      console.error('Error adding to cart:', error);
      throw error; // Re-throw the error to propagate it further if needed
    });
}

export function cartRemove(variantId) {
  const url = `${Shopify.routes.root}cart/change.js`;
  let body = {
    id: String(variantId),
    quantity: 0
  };
  const requestOptions = {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(body)
  };
  return fetch(url, requestOptions)
    .then(response => response.json())
    .catch(error => {
      console.error('Error removing from cart:', error);
      throw error; // Re-throw the error to propagate it further if needed
    });
}

export function cartUpdate(variantId, quantity, properties) {
  const url = `${Shopify.routes.root}cart/change.js`;
  let body = {
    id: String(variantId),
    quantity: quantity
  };
  // Add properties only if it is defined
  if (properties) {
    body.properties = properties;
  }
  const requestOptions = {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(body)
  };
  return fetch(url, requestOptions)
    .then(response => response.json())
    .catch(error => {
      console.error('Error updating cart:', error);
      throw error; // Re-throw the error to propagate it further if needed
    });
}



/* Product and Collections API functions */
export function fetchProductByName(handleName) {
  var url = '/products/' + handleName +'.js'
  return fetch(url).then(function (response) {
    return response.json().then(function (content) {
      return content;
    })
  }) 
}


export function fetchCollections(callback) {
  var url = `/collections.json?limit=100`
  return fetch(url).then(function (response) {
    return response.json().then(function (content) {
      return content;
    })
  }) 
}

export function fetchProductsFromCollection(collectionHandleName) {
  var url = `/collections/${collectionHandleName}/products.json?limit=100`
  return fetch(url).then(function (response) {
    return response.json().then(function (content) {
      return content;
    })
  }) 
}

